import React, { Fragment, useState, useEffect, useRef } from "react";
import {
  Table,
  Button,
  Card,
  CardTitle,
  Col,
  FormGroup,
  Input,
  Row,
  UncontrolledTooltip,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  NavbarToggler,
  Collapse,
  Nav,
} from "reactstrap";
import {
  AGENCYLIST_URL,
  AGENCY_DETAILS_URL,
  AGENCY_DELETE,
} from "../../../utils/APIEndpoints";
import { authHeader } from "../../../utils/functions/CoreFunctions";
import API from "../../../redux/actions/API";
import {
  SingleStringFirstLetterCaps,
  getAlertToast,
  getDateString,
  getCountryCode,
  formatIntoHyphenedTaxid,
  getConfirm,
} from "../../../utils/functions/CustomFunctions";
import CustomDeleteButton from "../../common/CustomDeleteButton";
import Checkbox from "react-custom-checkbox";
import * as Icon from "react-icons/fi";
import CustomViewButton from "../../common/CustomViewButton";
import CustomEditButton from "../../common/CustomEditButton";
import CustomTableLoader from "../../common/CustomTableLoader";
import CustomTableEmptyRecord from "../../common/CustomTableEmptyRecord";
import CustomTableHeader from "../../common/CustomTableHeader";
import Swal from "sweetalert2";
import Create from "./create";
import { useHistory, Link } from "react-router-dom";
import { ADMIN_AGENCYDETAILS_PATH } from "../../../utils/AppRoutes";
import Pagination from "react-js-pagination";
import { debounce } from "underscore";
import shortid from "shortid";

//Table Columns
const tableColumns = [
  { title: "Agency Name" },
  { title: "Account Holder Name" },
  { title: "Email" },
  { title: "Phone Number" },
  { title: "Created Date" },
  { title: "Actions" },
];

const AdminAgencies = (props) => {
  const history = useHistory();
  //State
  const a = 10;
  const [selected, setSelected] = useState([]);
  const [selectedlist, setSelectedlist] = useState(false);
  const [agencyList, setAgencyList] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [active, setActive] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [gridData, setGridData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [locationCodeFromResponse, setLocationCodeFromResponse] =
    useState(null); //Edit Purpose
  const [userData, setUserData] = useState({
    accountHolderName: "",
    accountNumber: "",
    companyName: "",
    locationCodeId: "",
    taxId: "",
    ifscCode: "",
    agencyEmail: "",
    agencyPhone: "",
    bankAddress: "",
    agencyAddress: "",
    autoApproval: false,
  });
  const [createModal, setCreateModal] = useState(false);
  const [isAdd, setIsAdd] = useState(true);
  const [filter, setFilter] = useState({
    companyName: "",
    agencyEmail: "",
    agencyPhone: "",
    count: 10,
  });

  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const filterToggle = () => {
    setIsFilterOpen(!isFilterOpen);
  };
  const createToggle = () => setCreateModal(!createModal);

  const onPageChanged = (page) => {
    setCurrentPage(page - 1);
    getGridData({
      ...filter,
      offset: page - 1,
    });
  };

  //Onchange filter
  const changeFilterField = ({ target: { name, value } }) => {
    setFilter({ ...filter, [name]: value });
  };

  const handleReset = () => {
    setFilter((val) => ({
      ...val,
      companyName: "",
      agencyEmail: "",
      agencyPhone: "",
    }));
  };

  const createRecord = async () => {
    setUserData({
      accountHolderName: "",
      accountNumber: "",
      companyName: "",
      locationCodeId: "",
      taxId: "",
      ifscCode: "",
      agencyEmail: "",
      agencyPhone: "",
      bankAddress: "",
      agencyAddress: "",
      autoApproval: false,
    });
    setCreateModal(true);
    setIsAdd(true);
  };

  const saveCallBack = () => {
    getGridData({
      ...filter,
      offset: currentPage,
    });
    createToggle(false);
  };

  const getRecord = async (agencyId, e) => {
    setLoading(true);
    setIsAdd(false);
    const options = {
      method: "GET",
      url: AGENCY_DETAILS_URL,
      headers: authHeader(),
      params: { agencyId },
    };
    try {
      const response = await API(options);
      const { status, agency, locationCodeDetails = [] } = response.data;
      if (status === "Success") {
        setCreateModal(true);
        setUserData({
          ...agency,
          taxId: formatIntoHyphenedTaxid(agency.taxId),
        });
        setLocationCodeFromResponse(locationCodeDetails);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast("error", data.message));
      }
    } finally {
      setLoading(false);
    }
  };

  const handleRowPerPage = ({ target: { value, name } }) => {
    setCurrentPage(0);
    setFilter((va) => ({ ...va, [name]: value || undefined }));
  };

  useEffect(() => {
    delayedQuery(filter);
  }, [filter]);

  //Debounce
  const delayedQuery = useRef(
    debounce(
      (filter) =>
        getGridData({
          ...filter,
          offset: currentPage,
        }),
      500
    )
  ).current;

  //Get Grid Data
  const getGridData = async (queryParams) => {
    try {
      setLoading(true);
      const options = {
        method: "GET",
        url: AGENCYLIST_URL,
        headers: authHeader(),
        params: queryParams,
      };
      const response = await API(options);
      const { status, data: initialResponse = [], totalCount } = response.data;
      if (status === "Success") {
        setTotalRecords(totalCount);
        let dataToDis = initialResponse.map((record) => {
          let { accountHolderName, createdDate } = record;
          let formattedData = {
            accountHolderName: SingleStringFirstLetterCaps(accountHolderName),
            createdDate: getDateString(createdDate),
          };
          let dataToReturn = { ...record, ...formattedData };
          return dataToReturn;
        });
        setGridData(dataToDis);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast("error", data.message));
      }
    } finally {
      setLoading(false);
    }
  };
  //delete record
  const deleteRecord = async () => {
    Swal.fire(
      getConfirm(
        "warning",
        "Documents and Users will be deleted  regarding to this agency Are you sure you want to continue?"
      )
    ).then((result) => {
      if (result.value) {
        deleteAdmin();
      }
    });
  };
  const deleteAdmin = async () => {
    console.log(selected.length);
    let values = [];
    selected.forEach((value) => {
      values.push({
        agencyId: value,
      });
    });
    console.log(values);
    try {
      setLoading(true);
      const option = {
        method: "DELETE",
        url: AGENCY_DELETE,
        header: authHeader(),
        data: {
          agencyList: values,
        },
      };
      const response = await API(option);
      const { status } = response.data;
      if (status == "Success") {
        getGridData({
          ...filter,
          count: rowsPerPage || undefined,
          offset: currentPage,
        });
      }

      console.log(selected);
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast("error", data.message));
      }
    } finally {
      setLoading(false);
    }
  };
  const cheackvalues = (e, agency) => {
    console.log(e);
    //console.log(agency)
    if (e == true) {
      selected.push(agency);
      setSelected([...selected], selected);
    } else {
      selected.shift(agency);
      setSelected([...selected], selected);
    }
  };
  const onChangeChecked = (e) => {
    console.log(e);
    let list = [];
    list.length = 0;
    if (selectedlist == false || e == true) {
      setSelectedlist(true);
      gridData.filter((record) => {
        selected.push(record.agencyId);
      });
      setSelected(selected);
    } else {
      setSelectedlist(false);

      gridData.map((record) => {
        selected.shift(record.agencyId);
      });
      list.splice(0, selected.length);
      // console.log(list);
      setSelected(list);
    }
  };

  // console.log(selected);
  // console.log(selected.length);
  const { companyName, agencyEmail, agencyPhone } = filter;
  return (
    <Fragment>
      <div>
        <Nav className="mr-auto" navbar></Nav>
        <Card body className="mt-5">
          <div className="tableTitleBg mb-4">
            <CardTitle className=" " style={{ margin: "0" }}>
              {" "}
              Agencies
            </CardTitle>
            <i
              className="fas fa-filter"
              style={{
                float: "right",
                margin: "0px 7px 3px 16px",
                fontSize: "19px",
                cursor: "pointer",
              }}
              onClick={filterToggle}
            ></i>

            <Button className="f-r" color="primary" onClick={createRecord}>
              <i className="fas fa-users"></i> New Agency
            </Button>

            {selected.length > 0 ? (
              <CustomDeleteButton onClick={deleteRecord} />
            ) : (
              ""
            )}
          </div>
          {isFilterOpen && (
            <Row form className="mb-4">
              <Col md={3}>
                <FormGroup>
                  <Input
                    type="text"
                    name="companyName"
                    placeholder="Agency Name"
                    onChange={changeFilterField}
                    value={companyName}
                  />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <Input
                    type="text"
                    name="agencyEmail"
                    placeholder="Email"
                    onChange={changeFilterField}
                    value={agencyEmail}
                  />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>+1</InputGroupText>
                    </InputGroupAddon>
                    <Input
                      type="text"
                      name="agencyPhone"
                      placeholder="Phone Number"
                      onChange={changeFilterField}
                      value={agencyPhone}
                    />
                  </InputGroup>
                </FormGroup>
              </Col>
              <Col md={2}>
                <div style={{ marginTop: "4px" }}>
                  <Button color="danger" onClick={handleReset}>
                    Reset
                  </Button>
                </div>
              </Col>
            </Row>
          )}
          <Table responsive hover>
            {/* Table Header */}

            <thead style={{ backgroundColor: "#eee" }}>
              <tr>
                <th>
                  {
                    <Checkbox
                      icon={<Icon.FiCheck color="#174A41" size={14} />}
                      borderColor="#D7C629"
                      checked={selectedlist}
                      onChange={onChangeChecked}
                      style={{ cursor: "pointer" }}
                    />
                  }
                </th>

                {tableColumns.map(({ title }, key) => (
                  <th key={`head_list_${key}`}>{title}</th>
                ))}
              </tr>
            </thead>

            {/* <CustomTableHeader tableColumns={tableColumns} /> */}

            {/* Table Header */}
            <tbody>
              {loading ? (
                // Table Loader
                <CustomTableLoader columnsCount={tableColumns.length} />
              ) : (
                // Table Loader
                <Fragment>
                  {!gridData.length ? (
                    //  Empty Record
                    <CustomTableEmptyRecord
                      columnsCount={tableColumns.length}
                    />
                  ) : (
                    //  Empty Record
                    <Fragment>
                      {gridData.map((record, key) => (
                        <tr key={`record_key_${key}`}>
                          <td>
                            {
                              <Checkbox
                                icon={
                                  <Icon.FiCheck color="#174A41" size={14} />
                                }
                                borderColor="#D7C629"
                                style={{ cursor: "pointer" }}
                                //checked={active}
                                checked={selectedlist}
                                onChange={(e) =>
                                  cheackvalues(e, record.agencyId)
                                }
                              />
                            }
                          </td>
                          <td>{record.companyName}</td>
                          <td>{record.accountHolderName}</td>
                          <td>{record.agencyEmail}</td>
                          <td>
                            {getCountryCode()}
                            {record.agencyPhone}
                          </td>
                          <td>{record.createdDate}</td>
                          <td>
                            {/* Custom View Button  */}
                            <Link
                              to={{
                                pathname:
                                  ADMIN_AGENCYDETAILS_PATH +
                                  "/" +
                                  record.agencyId,
                                state: { gotoTab: 1 },
                              }}
                            >
                              <CustomViewButton
                                keyvalue={key}
                                data-user_id={record.userId}
                              />
                            </Link>
                            {/* Custom View Button  */}

                            {/* Custom Edit Button  */}
                            <CustomEditButton
                              keyvalue={key}
                              data-user_id={record.userId}
                              onClick={(e) => getRecord(record.agencyId, e)}
                            />
                            {/* Custom Edit Button  */}
                            <Link
                              to={{
                                pathname:
                                  ADMIN_AGENCYDETAILS_PATH +
                                  "/" +
                                  record.agencyId,
                                state: { gotoTab: 3 },
                              }}
                            >
                              <Button
                                className="action-btn"
                                color="primary"
                                id={`tooltip_add_key_${key}`}
                              >
                                <span className="fas fa-user-plus"></span>
                              </Button>
                            </Link>
                            <UncontrolledTooltip
                              placement="top"
                              target={`tooltip_add_key_${key}`}
                            >
                              Add Agency Users
                            </UncontrolledTooltip>
                          </td>
                        </tr>
                      ))}
                    </Fragment>
                  )}
                </Fragment>
              )}
            </tbody>
            {/* Table Body */}
          </Table>
          {gridData.length ? (
            <div className="d-flex py-4 justify-content-end space_between">
              <div className="space_between">
                <div>
                  <p className="per_page">Records/Page</p>
                </div>
                <div>
                  <FormGroup>
                    <Input
                      className="pagi_drop"
                      type="select"
                      name="count"
                      onChange={handleRowPerPage}
                      value={filter.count}
                    >
                      <option value={""}>Show All</option>
                      <option value={10}>10</option>
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                    </Input>
                  </FormGroup>
                </div>
              </div>
              {filter.count && (
                <div>
                  <Pagination
                    itemClass="page-item"
                    linkClass="page-link"
                    activePage={currentPage + 1}
                    itemsCountPerPage={filter.count}
                    totalItemsCount={totalRecords}
                    onChange={onPageChanged}
                  />
                </div>
              )}
            </div>
          ) : (
            ""
          )}
        </Card>
      </div>
      {/* create Modal */}
      {createModal && (
        <Create
          modal={createModal}
          toggle={createToggle}
          data={userData}
          locationCodeFromResponse={locationCodeFromResponse}
          isAdd={isAdd}
          saveCallBack={saveCallBack}
        />
      )}
      {/* end create Modal */}
    </Fragment>
  );
};
export default AdminAgencies;
